import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import TressCheckboxList from "./TressCheckboxList.vue";
import TressDropdown from "./TressDropdown.vue";
import TressFrame from "./TressFrame.vue";
import { TressAccordion, TressAccordionItem } from "./TressAccordion";
import { Facet, FacetAvailable } from "@/models/Search";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressFilter',
  props: {
    filters: {},
    selectedFilters: {},
    title: {},
    showMoreText: {}
  },
  emits: ["selectFilter"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const _selectedFilters = computed({
  get: () => props.selectedFilters ?? [],
  set: (val: string[]) => {
    emits("selectFilter", val);
  },
});

const hasLevels = computed(() => props.filters?.levels && props.filters.levels.length > 1);

function createOption(facet: FacetAvailable): { value: string; label: string } {
  return { value: facet.value as string, label: `${facet.value} (${facet.hits})` };
}
const availableOptions = computed(() => props.filters?.available.map(createOption) ?? []);
const levelOptions = computed(() => {
  return (
    props.filters?.levels.flatMap((level) => ({
      name: level.levelName,
      options: level.available.map(createOption),
    })) ?? []
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TressDropdown, { title: _ctx.title }, {
    default: _withCtx(() => [
      _createVNode(TressFrame, { class: "dropdown-frame" }, {
        default: _withCtx(() => [
          (!hasLevels.value)
            ? (_openBlock(), _createBlock(TressCheckboxList, {
                key: 0,
                modelValue: _selectedFilters.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_selectedFilters).value = $event)),
                "show-more-text": _ctx.showMoreText,
                options: availableOptions.value
              }, null, 8, ["modelValue", "show-more-text", "options"]))
            : _createCommentVNode("", true),
          _createVNode(_unref(TressAccordion), { dense: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(levelOptions.value, (level) => {
                return (_openBlock(), _createBlock(_unref(TressAccordionItem), {
                  title: level.name,
                  key: level.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(TressCheckboxList, {
                      "show-more-text": _ctx.showMoreText,
                      modelValue: _selectedFilters.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_selectedFilters).value = $event)),
                      options: level.options
                    }, null, 8, ["show-more-text", "modelValue", "options"])
                  ]),
                  _: 2
                }, 1032, ["title"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})